<div class="tCol clickCol desktop" id="RowSelect4_{{ item.id }}">
  @if (!item.roleItem) {
    <div [ngClass]="{ tYes: item.active, tNo: !item.active }" class="inviteStatus"></div>
  }
</div>
